let searchParams = new URLSearchParams(window.location.search);
let id = addAndGetFromLocalStorage("id", searchParams.get('id'));
let utmCampaign = addAndGetFromLocalStorage("utm_campaign", searchParams.get('utm_campaign'));
let utmSource = addAndGetFromLocalStorage("utm_source", searchParams.get('utm_source'));
let utmMedium = addAndGetFromLocalStorage("utm_medium", searchParams.get('utm_medium'));
let utmTerm = addAndGetFromLocalStorage("utm_term", searchParams.get('utm_term'));

let form = document.querySelector('#contact_form');
if(form !== null){
  if(id !== null){
    createInputField('id', id, form);
  }
  if(utmCampaign !== null){
    createInputField('utm_campaign', utmCampaign, form);
  }
  if(utmSource !== null){
    createInputField('utm_source', utmSource, form);
  }
  if(utmMedium !== null){
    createInputField('utm_medium', utmMedium, form);
  }
  if(utmTerm !== null){
    createInputField('utm_term', utmTerm, form);
  }
}

function createInputField(name, value, target){
	let input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", "contact[" + name + "]");
    input.setAttribute("value", value);
    target.appendChild(input);
}

function addAndGetFromLocalStorage(key, value){
  if(value !== null && localStorage.getItem(key) !== null){
    localStorage.removeItem(key);
    localStorage.setItem(key, value);
    return localStorage.getItem(key);
  } else if(value === null && localStorage.getItem(key) !== null){
  	return localStorage.getItem(key);
  } else if(value !== null && localStorage.getItem(key) === null){
  	localStorage.setItem(key, value);
    return localStorage.getItem(key);
  }
  return null;
}